import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['discoveryCurrentWebsiteAccordion', 'targetedMainCityText']

  onAlreadyHasWebsiteChange(event) {
    this.discoveryCurrentWebsiteAccordionTargets.forEach(element => {
      if (event.currentTarget.dataset.projectQualificationId == element.dataset.projectQualificationId) {
        element.classList.toggle('hide')
      }
    })
  }

  onTargetedMainCityChange(event) {
    this.targetedMainCityTextTargets.forEach(element => {
      if(event.currentTarget.dataset.projectQualificationId == element.dataset.projectQualificationId) {
        element.innerHTML = event.currentTarget.options[event.currentTarget.selectedIndex].text
      }
    })
  }
}
